import { TConfig, TConfigInput, TConfigParams } from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';
import { featureFlag } from '../../featureFlags';

function ToggleORConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled(featureFlag.IS_OR_EXPANSION_ENABLED)
    ? {
        autoDiscounts: () => [
          AUTO_DISCOUNTS.affinity,
          AUTO_DISCOUNTS.matureDriver55,
          AUTO_DISCOUNTS.safeDriving,
          AUTO_DISCOUNTS.multiCar,
          AUTO_DISCOUNTS.multiPolicy,
          AUTO_DISCOUNTS.homeowner,
          AUTO_DISCOUNTS.goodStudent,
          AUTO_DISCOUNTS.distantStudent,
          AUTO_DISCOUNTS.teenDriver,
        ],
        excludeDriversViewConfig: (
          excludeDriversViewConfig: TConfig['excludeDriversViewConfig']
        ) => ({
          ...excludeDriversViewConfig,
          explanationText:
            'An excluded driver will have no coverage or will have a reduction in coverage, depending on the type of coverage, when driving any vehicle listed on the policy. If you choose not to exclude this driver, you will not be eligible for coverage with Toggle.',
        }),
        matureDriver: () => ({
          getSubjectText: null,
          label:
            'Has this person completed a mature driver motor vehicle accident prevention course?',
          explanation:
            'Approved defensive driving courses designed for mature drivers help improve driving skills and reduce driving risks by anticipating situations and making safe well-informed decisions. Courses required because of a driving offense or traffic violation do not apply.',
        }),
        coverage: (coverage: TConfig['coverage']) => ({
          ...coverage,
          personalInjuryProtection: {
            title: 'Personal Injury Protection',
            description:
              'Accidents can be scary, especially when you or someone you love is injured. If that happens, though, this coverage can help lessen the impact to your wallet (or theirs).',
            modalContent:
              'Personal Injury Protection (PIP) coverage could pay for reasonable medical expenses, funeral expenses, lost income, and essential services incurred by an insured person on your policy or household member caused by an accident regardless of fault. This is a mandatory coverage.',
            textAlertContent: '',
          },
          uninsuredMotoristPropertyDamage: {
            title: 'Uninsured Motorist Property Damage',
            description: `Your bumper sticker might say 'don't hit me if you're uninsured' but it isn't actually protecting you against that. Don't worry, this coverage can help.`,
            modalContent:
              'Uninsured Motorist Property Damage (UMPD) pays, subject to the applicable deductible, the amount you are legally entitled to recover for physical damages to your insured car sustained in an accident caused by a driver who is not insured.',
          },
        }),
        initialCoverageValues: (
          initialCoverageValues: TConfig['initialCoverageValues']
        ) => ({
          ...initialCoverageValues,
          temporary_ride: 'null',
          gap: 'false',
          side_hustle: 'false',
        }),
        vehicleSideEffectMessages: (
          vehicleSideEffectMessages: TConfig['vehicleSideEffectMessages']
        ) => ({
          ...vehicleSideEffectMessages,
          new_car_replacement: `This coverage is only available if Comprehensive & Collision is also selected and the model year is two (2) years old or less.`,
          gap:
            'This coverage is only available if Comprehensive and Collision are also selected, the vehicle is financed or leased, and the model year is four (4) years old or less.',
        }),
        visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
          return {
            ...visibleCoverages,
            protectionCoverages: [
              ...visibleCoverages.protectionCoverages.filter(
                ({ key }) =>
                  ![
                    'medical_limit',
                    'pet_passenger',
                    'uninsured_motorist_property_damage_limit',
                    'underinsured_motorist_property_damage_limit',
                    'personal_injury_protection_limit',
                  ].includes(key)
              ),
              {
                label: 'Uninsured Motorist Property Damage',
                key: 'uninsured_motorist_property_damage_limit',
              },
              {
                label: 'Personal Injury Protection',
                key: 'personal_injury_protection_limit',
              },
              visibleCoverages.protectionCoverages.find(
                ({ key }) => key === 'pet_passenger'
              ),
            ],
            vehicleCoverages: [...visibleCoverages.vehicleCoverages],
          };
        },
        coverageMarkOverrides: () => ({
          uninsured_motorist_property_damage_limit: {
            value: 20000,
            label: 'On',
          },
        }),
      }
    : {};
}
export default ToggleORConfig;
